import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
import { withCancelToken } from '@wix/form-http-essentials';
export const queryServiceByFormId = async ({ httpClient, errorHandler, formId, signal })=>{
    try {
        const response = await errorHandler.withErrorHandler(()=>httpClient.request(withCancelToken(queryServices({
                query: {
                    filter: {
                        'form.id': {
                            $in: [
                                formId
                            ]
                        }
                    }
                }
            }), signal, httpClient)), {
            errorCodesMap: {}
        });
        return response.data.services?.[0];
    } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        console.error(resolvedError);
        return undefined;
    }
};

//# sourceMappingURL=query-service-by-form-id.js.map